import * as React from 'react'

import { GatheringRegistrations_gatheringRegistrations } from 'main/gql/registration/'
import { REGISTRATION_QUERY } from 'main/gql/registration/RegistrationQuery'
import { Button, palette, spacing, Text } from 'main/ui'
import { Mutation } from 'react-apollo'
import {
  UPDATE_GATHERING_REGISTRATION_MUTATION,
  UpdateGatheringRegistration,
  UpdateGatheringRegistration_updateGatheringRegistration,
  UpdateGatheringRegistrationMutationFn,
  UpdateGatheringRegistrationVariables,
} from '../../gql'
import {
  default as RegistrationSection,
  validate as validateQuantity,
} from '../../RegistrationSection'
import { handleError } from './../../util'

interface IProps {
  registration: GatheringRegistrations_gatheringRegistrations
  onComplete: (registration: UpdateGatheringRegistration_updateGatheringRegistration) => void
}

interface IParams {
  quantity: number
}

interface IValidation {
  quantity?: string
}

export default function Register(props: IProps) {
  const { registration, onComplete } = props
  const { id, gatheringId, quantity } = registration
  const [params, setParams] = React.useState<IParams>({ quantity })

  const [validationHints, setValidationHints] = React.useState<IValidation>({})
  const [error, setError] = React.useState<string | null>(null)

  return (
    <div>
      {error && <Text css={{ color: palette.rose }}>{error}</Text>}

      <RegistrationSection
        validation={{ quantity: validationHints.quantity }}
        params={{ quantity: params.quantity }}
        onChange={updatedQuantity => handleChange(updatedQuantity, setParams)}
      />
      <Mutation<UpdateGatheringRegistration, UpdateGatheringRegistrationVariables>
        mutation={UPDATE_GATHERING_REGISTRATION_MUTATION}
        onCompleted={data => {
          if (data.updateGatheringRegistration) onComplete(data.updateGatheringRegistration)
        }}
        onError={apolloError => handleError(apolloError, setError)}
        refetchQueries={[
          {
            query: REGISTRATION_QUERY,
            variables: { gatheringId },
          },
        ]}
      >
        {(mutate, { loading }) => (
          <Button
            css={{ marginTop: spacing.majorScale(4) }}
            disabled={loading}
            onClick={() => handleSubmit(id, params, setValidationHints, mutate)}
            full
          >
            Update RSVP
          </Button>
        )}
      </Mutation>
    </div>
  )
}

function handleChange(
  changes: Partial<IParams>,
  setParams: React.Dispatch<React.SetStateAction<IParams>>,
) {
  setParams(params => ({ ...params, ...changes }))
}

function handleSubmit(
  gatheringRegistrationId: number,
  params: IParams,
  setValidationHints: React.Dispatch<React.SetStateAction<IValidation>>,
  mutate: UpdateGatheringRegistrationMutationFn,
) {
  const validationHints = validateQuantity(params)

  if (Object.keys(validationHints).length > 0) {
    return setValidationHints(validationHints)
  }

  const variables: UpdateGatheringRegistrationVariables = {
    gatheringRegistration: { quantity: params.quantity },
    gatheringRegistrationId,
  }

  mutate({ variables })
}
